<template>
    <body id="app">
        <app-head></app-head>
        <app-nav></app-nav>
        <router-view class="main-container"></router-view>
    </body>
</template>

<script>
import Head from './components/_Head';
import Navbar from './components/_Navbar';

export default {
    components: {
        appHead: Head,
        appNav: Navbar,
    },
};
</script>

<style lang="sass">
*
    box-sizing: border-box
body, html
    margin: 0
    font-family: sans-serif

.main-container
    padding-top: 51px

.column
    float: left
    padding: 10px

.left
    width: 25%
    margin: 0

.right
    width: 75%
    background-color: white

.row:after
    content: ""
    display: table
    clear: both

a
    color: rgba(224, 81, 32, 0.8)

th, td
    text-align: left
    padding: 16px

tr:nth-child(even)
    background-color: #f2f2f2

hr.chapter-split
    opacity: 0.2
    width: calc(100%*2/3)
    margin-top: 1em
    margin-bottom: 1em
</style>
